/**
 *  Base component - extended by others
 */
import State from '../state'


export default class Component {

    constructor() {
        this.state = new State() /* Enable access to global state through this.state */
    }

    getParam(param) {

        var pageURL = window.location.search.substring(1);
        var URLVariables = pageURL.split('&');

        // main.doLog('Query string values:');

        for (var i = 0; i < URLVariables.length; i++) {
            var queryString = URLVariables[i].split('=');

            // main.doLog('Key: ' + queryString[0] + ', Value:  ' + queryString[1]);

            if (queryString[0] == param) {
                return queryString[1];
            }
        }

        return "";

    }

    scrollTo (elem) {

        var scrollTop = $(elem).position().top - 20;

        setTimeout(function() {
            $('html, body').animate({
                    scrollTop: scrollTop
                }, 500, function () {
                }
            );
        }, 500);
    
    }

    isObject(value) {
        var datatype = typeof value;
        return datatype === 'function' || datatype === 'object' && !!value;
    }


    doLog(msg, o) {

        var debugParam = this.getParam('debug');

        //
        // TODO
        //
        // => REMOVE this console variable, it's just temporary
        // debugParam = true;

        if (debugParam) {

            msg = this.TAG + ' - ' + msg;

            if (o) {
                console.log(msg, o);
            } else {
                console.log(msg);
            }
        }

    }


    
    showBtnElement(btnelem) {
        
        $(btnelem).removeAttr('disabled');
        $(btnelem).addClass('blue');
        
    }

    hideBtnElement(btnelem) {

        $(btnelem).attr('disabled', true);
        $(btnelem).removeClass('blue');

    }
    
}